import React from 'react'

import PropTypes from 'prop-types'

/**
 * DEPRECATED: This component is deprecated and will be removed in the future.
 * ticket: https://gousto.atlassian.net/browse/TOM-19
 */
export const Content = (props) => {
  const handleInjectHtml = (component) => component

  const handleInjectReact = (component) =>
    React.cloneElement(component, {}, component.props.children)

  const injectContent = (child) => {
    if (!React.isValidElement(child)) return child
    if (typeof child.type === 'function') return handleInjectReact(child)

    return handleInjectHtml(child)
  }

  return injectContent(props.children)
}

Content.propTypes = {
  children: PropTypes.node.isRequired,
  contentKeys: PropTypes.string.isRequired,
  propNames: PropTypes.string,
}
